import { useSearchParams } from 'react-router-dom';

/**
 *
 * @param key : string 또는 string[]을 받아 searchParams에서 해당 key의 value를 반환
 * @returns string[]
 */
const useGetSearchParams = (key: string | string[]) => {
	const [searchParams] = useSearchParams();

	if (typeof key === 'string') return [searchParams.get(key) as string];

	return key.map((k) => searchParams.get(k) as string);
};

export default useGetSearchParams;
